import React from "react";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";

export default function CognitiveExercisesPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[#cdeaff]">
      <Sidebar active="cognitive-exercises" />

      <main className="flex-1 px-0 pt-6 pb-0">
        <div className="h-full w-full rounded-tl-xl border border-black/10 bg-white/60 p-6 backdrop-blur">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className="text-3xl font-semibold text-gray-900">Kognitive Übungen</h1>
              <p className="mt-2 text-sm text-gray-700">
                Hier findest du eine Übersicht aller verfügbaren kognitiven Spiele.
              </p>
            </div>

            <div className="inline-flex items-center rounded-full bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm">
              1 Spiel
            </div>
          </div>

          <section className="mt-8">
            <button
              type="button"
              onClick={() => navigate("/quizzes")}
              className={[
                "w-full md:max-w-2xl rounded-2xl border border-black/10 bg-white p-6 text-left shadow-sm transition",
                "hover:border-[#76B3FF]/60 hover:bg-[#F8FBFF]",
              ].join(" ")}
            >
              <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                <div>
                  <h2 className="text-2xl font-semibold text-gray-900">Quizzes</h2>
                  <p className="mt-3 text-sm leading-6 text-gray-700">
                    Erstelle Quizzes zu verschiedenen Themen mit unterschiedlichen Schwierigkeitsgraden.
                  </p>
                </div>
                <span className="inline-flex items-center rounded-full bg-[#DDF0FF] px-3 py-1 text-xs font-semibold text-[#265DAB]">
                  Öffnen
                </span>
              </div>
            </button>
          </section>
        </div>
      </main>
    </div>
  );
}
